import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { SerasaConsultaResponseItem } from '../../../services/serasaService';

interface Props {
  data: SerasaConsultaResponseItem[];
}

const ConsultaSerasaResultDisplay: React.FC<Props> = ({ data }) => {
  if (data.length === 0) {
    return <div className="alert alert-info mt-3">Nenhum registro encontrado.</div>;
  }
  
  const headers = [
      "cpf/cnpj", "contrato", "Data Cadastro", "Data Conclusao", 
      "Status Registro", "Resultado Analise", "Protocolo BrFlow"
  ];

  return (
    <div className="table-responsive mt-4">
      <table className="table table-bordered table-striped table-hover">
        <thead className="table-light">
          <tr>
            {headers.map(header => <th key={header}>{header}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td>{row.cpfcnpj}</td>
              <td>{row.contrato}</td>
              <td>{row.DataCadastro}</td>
              <td>{row.DataConclusao}</td>
              <td>{row.StatusRegistro}</td>
              <td>{row.ResultadoAnalise}</td>
              <td>{row.ProtocoloBrFlow}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ConsultaSerasaResultDisplay;